import * as Application from './application/Application';
import * as Authentication from './authentication/Authentication';
import * as SearchBar from './components/search/SearchBar';
import * as FilterDialog from './components/search/filter/FilterDialog';
import * as SavedFilter from './components/search/filter/SavedFilter';
import * as SignIn from './authentication/SignIn';
import * as SignOut from './authentication/SignOut';
import * as Cookie from './Cookie';
import * as Download from './ajax/Download';
import * as Upload from './ajax/Upload';
import * as DispatcherActions from './Dispatcher';
import * as UploadPanel from './UploadPanel';
import * as ActivityBadge from './components/layout/viewport/sidebar/component/ActivityBadge';
import * as Sidebar from './components/layout/viewport/sidebar/Sidebar';
import * as Dashboard from './components/dashboard/Dashboard';
import * as GridAction from './components/grid/Grid';
import * as TabPanelForm from './components/tab_panel_form/TabPanelForm';
import * as TabPanel from './components/tab_panel/TabPanel';
import * as PuzzleInputWithExistingValidation from '../actions/components/fields/input/PuzzleInputWithExistingValidation';
import * as ToastNotifications from './components/toast_notifications/ToastNotifications';

export default {
  ...ActivityBadge,
  ...Application,
  ...Authentication,
  ...Cookie,
  ...DispatcherActions,
  ...Download,
  ...Dashboard,
  ...SearchBar,
  ...Sidebar,
  ...FilterDialog,
  ...SavedFilter,
  ...GridAction,
  ...SignIn,
  ...SignOut,
  ...Upload,
  ...UploadPanel,
  ...TabPanelForm,
  ...TabPanel,
  ...PuzzleInputWithExistingValidation,
  ...ToastNotifications
};
